// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__LOSFX","slideUp":"LoadingSpinner_slideUp__-EUpf","slideDown":"LoadingSpinner_slideDown__dGEkM"};